<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>

    <tableList ref="multipleTable" :table-query="search" :query-function="$Api.activity.postAggregation" size="small" style="width: 100%">
      <!-- <el-table-column type="selection" width="55" fixed /> -->
      <el-table-column prop="id" label="活动ID" />
      <el-table-column prop="name" label="活动标题" />

      <el-table-column fixed="right" width="130px" label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="copyLink(row)">复制链接</el-button>
        </template>
      </el-table-column>
    </tableList>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
  </div>
</template>
<script>
// import { mapState } from 'vuex'
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';

export default {
  components: { tableList, Dialog },
  data() {
    const activityStatus = [
      { id: 0, value: '已发布', color: 'success' },
      { id: 1, value: '草稿', color: 'warning' },
      { id: 2, value: '已发布', color: 'success' },
      { id: 3, value: '已结束', color: 'info' },
      { id: 4, value: '草稿', color: 'warning' },
    ];
    return {
      search: {
        // city: '',
        status: '',
        name: '',
        beginTime: '',
      },
      activityStatus,
      selectionId: [],
      formDialogShow: false,
      currentID: -1,
      information: {},
    };
  },

  methods: {
    add() {
      this.$router.push({ path: '/activity/activityAggregationPage/add' });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      const subTitle = `是否确认编辑活动ID为“${row.id}”的数据项？`;
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle,
      };
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后小程序用户将无法查看该活动，请确认是否删除',
        // subTitle: `是否确认删除活动ID为“${row.id}”的数据项？`,
      };
    },
    copyLink(row) {
      // 把汗流漂亮小程序路径
      let page = `pages/activity-group-sweat/index?id=`;
      if (!row.id) return;
      page += row.id;
      navigator.clipboard.writeText(page).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    submitSucces(operation) {
      if (operation === 'copy') {
        this.$router.push({ path: '/activity/activityAggregationPage/add', query: { copyid: this.currentID } });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/activity/activityAggregationPage/edit', query: { id: this.currentID } });
      }
    },

  },
};
</script>
